module.exports = __webpack_public_path__ + "img/avatar_7.ecc34d95.svg";